module.exports = __webpack_public_path__ + "eff2c81c27096e20eb2aafbc1fc678e2.png";